import { render } from "./PlanillaDet_PlaDetObs.vue?vue&type=template&id=e2577d2a&scoped=true"
import script from "./PlanillaDet_PlaDetObs.vue?vue&type=script&lang=js"
export * from "./PlanillaDet_PlaDetObs.vue?vue&type=script&lang=js"

import "./PlanillaDet_PlaDetObs.vue?vue&type=style&index=0&id=e2577d2a&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=e2577d2a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2577d2a"]])

export default __exports__